import React from 'react';
import { Container } from './styles';

const Loader: React.FC = () => {
  return (
    <Container>
      <div />
      <div />
      <div />
      <div />
    </Container>
  );
};

export default Loader;
